<div class="notify-dialog ups-dialog">
    <h2 *ngIf="title" mat-dialog-title>{{ title }}</h2>
    <mat-dialog-content>
        <div class="dialog-content {{ messageClass }}">
            <p *ngFor="let message of messages" [innerHtml]="message"></p>
        </div>
    </mat-dialog-content>
    <button class="icon-button close-button" mat-dialog-close mat-raised-button type="button" tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>
